<template>
    <console-layout width="100%" max-width="1300">

        <console-title>
            <span>CP 화이트 리스트</span>
        </console-title>

        <console-search @search="page=1; search(true)">
            <v-row align="center">
                <v-col cols="12" sm="4">
                    <v-select v-model="filter.searchKey" :items="searchKeys" label="검색조건" persistent-placeholder hide-details @input="filter.searchValue = null;"></v-select>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field v-model="filter.searchValue" label="검색어" persistent-placeholder hide-details :disabled="!filter.searchKey" @keydown.enter="page = 1; search(true);"></v-text-field>
                </v-col>
            </v-row>
        </console-search>

        <console-body>
            <v-data-table :items="ipItems" :headers="ipItemsHeaders" hide-default-footer disable-sort class="elevation-1">
                <template #[`item.actions`]="{item}">
                    <v-icon small @click="edit(item)">mdi-pencil</v-icon>
                    <v-icon v-if="$hasScope(['root', 'admin'])" small class="ml-1" @click="remove(item)">mdi-delete</v-icon>
                </template>
                <template #[`item.createdAt`]="{item}">
                    {{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}
                </template>
                <template #[`item.updatedAt`]="{item}">
                    {{ item.updatedAt ? $dayjs(item.updatedAt).format("YYYY-MM-DD HH:mm:ss") : "-" }}
                </template>
                <template #[`item.writer.name`]="{item}">
                    <div>{{ item?.writer?.name }}{{ item?.writer?.username ? `(${item?.writer?.username})` : "" }}</div>
                </template>
            </v-data-table>
    
            <v-pagination v-model="page" :length="pageCount" total-visible="11" class="mt-3" @input="search(true)"/>
        </console-body>

        <v-btn v-if="$hasScope(['root', 'admin'])" color="accent" fab fixed bottom right dark @click="create"><v-icon>mdi-pencil</v-icon></v-btn>

    </console-layout>
</template>

<script>
import api from "@/api";
import { mdiMicrosoftExcel } from "@mdi/js";

export default {
    data(){
        return {
            mdiMicrosoftExcel,

            showSearch: true,

            filter: {
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null,
                code: "cp"
            },

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "이름", value: "name" },
                { text: "IP", value: "ip" },
                { text: "연락처", value: "phone" },
            ],

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,

            ipItems: [],
            ipItemsHeaders: [
                { text: "이름", value: "name", align: "center" },
                { text: "IP", value: "ip", align: "center" },
                { text: "연락처", value: "phone", align: "center" },
                { text: "사유", value: "reason", align: "center" },
                { text: "생성일자", value: "createdAt", align: "center", width: 200 },
                { text: "수정일자", value: "updatedAt", align: "center", width: 200 },
                { text: "최종수정인", value: "writer.name", align: "center", width: 110 },
                { text: "actions", value: "actions", align: "center", width: 100 },
            ]
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            await this.search();
        },

        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            let { summary, ipItems } = await api.console.ip.gets({
                headers: {
                    skip: (this.page -1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            })
            this.ipItems = ipItems
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },

        create(){
            this.$router.push(`/console/cp/whitelist/create`);
        },

        edit(ip){
            this.$router.push(`/console/cp/whitelist/${ip._id}`);
        },

        async remove(ip){
            if(confirm("정말 삭제하시겠습니까?")){
                await api.console.ip.delete(ip);
                alert("삭제되었습니다");
                this.search();
            }
        }
    }
}
</script>